import { Dispatch } from 'redux'
import { clearPrescriptionPeriod } from 'core/modules/prescriptionPeriod'

export function callClearPrescriptionPeriod() {
  return async (dispatch: Dispatch) => {
    dispatch(clearPrescriptionPeriod())
  }
}
